module.exports = __webpack_public_path__ + "img/bill.6fcc8d32.svg";